<template>
  <hm-content title="">
    <div class="table-panel flex flex-between" v-if="isRedpackageSupplier">
      <div v-if="isRedpackageSupplier">
        当前供货商:<span class="primary">{{ storeName }}</span>
      </div>
      <div>
        <el-select
            size="small"
            clearable
            placeholder="请选择扣减类型"
            v-model="searchCondition.accountType"
            class="mr10"
            filterable
        >
          <el-option v-if="!isRedpackageSupplier" label="代发分销佣金扣减" value="share"></el-option>
          <el-option v-if="!isRedpackageSupplier" label="短信扣减" value="sms"></el-option>
          <el-option v-if="!isRedpackageSupplier" label="身份认证扣减" value="idCard"></el-option>
          <el-option v-if="isRedpackageSupplier" label="红包审核扣减" value="rdPack"></el-option>
        </el-select>
        <el-select
            size="small"
            clearable
            placeholder="请选择扣费状态"
            v-model="searchCondition.tradeMode"
            class="mr10"
            filterable
        >
          <el-option label="退还" value="in"></el-option>
          <el-option label="扣减" value="out"></el-option>
        </el-select>
        <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchCondition.rechargeTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="请选择使用时段"
            end-placeholder="请选择使用时段"
        ></el-date-picker>
        <el-input
            clearable
            v-model.trim="searchCondition.memberMobile"
            placeholder="请输入导购手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>


      <!-- <el-button
        size="small"
        type="success"
        @click="output('queryAllList', '充值流水')"
        :loading="isOutputing"
        >导出</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="outputAccount()"
        :loading="isOutputing"
        >导出对账单</el-button
      > -->
    </div>

    <div class="table-panel flex flex-end" v-else>
      <div>
        <el-select
            size="small"
            clearable
            placeholder="请选择项目类型"
            v-model="searchCondition.accountType"
            class="mr10"
            filterable
        >
          <el-option label="代发分销佣金" value="share"></el-option>
          <el-option label="短信" value="sms"></el-option>
          <el-option label="身份认证" value="idCard"></el-option>
        </el-select>
        <el-select
            size="small"
            clearable
            placeholder="请选择项目状态"
            v-model="searchCondition.tradeMode"
            class="mr10"
            filterable
        >
          <el-option label="退还" value="in"></el-option>
          <el-option label="扣减" value="out"></el-option>
          <el-option label="充值" value="recharge"></el-option>
        </el-select>
        <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchCondition.rechargeTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="请选择充值时段"
            end-placeholder="请选择充值时段"
        ></el-date-picker>
        <el-input
            clearable
            v-model.trim="searchCondition.memberMobile"
            placeholder="请输入导购手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>


      <!-- <el-button
        size="small"
        type="success"
        @click="output('queryAllList', '充值流水')"
        :loading="isOutputing"
        >导出</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="outputAccount()"
        :loading="isOutputing"
        >导出对账单</el-button
      > -->
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="项目"
          prop="templateCode"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.accountType === 'share'">
              代发分销佣金
            </div>
            <div v-else-if="scope.row.accountType === 'sms'">
              短信
            </div>
            <div v-else-if="scope.row.accountType === 'idCard'">
              身份认证
            </div>
            <div v-else-if="scope.row.accountType === 'rdPack'">
              红包审核扣减
            </div>
            <div v-else-if="scope.row.accountType === 'recharge'">
              充值
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="变动状态"
          prop="templateCode"
        >
          <template slot-scope="scope">
            <div :class="scope.row.tradeMode === 'out' ? 'success' : 'danger'" v-if="scope.row.tradeMode === 'out'">
              扣减
            </div>
            <div :class="scope.row.tradeMode === 'out' ? 'success' : 'danger'" v-else-if="scope.row.tradeMode === 'in'">
              退还
            </div>
            <div :class="scope.row.tradeMode === 'out' ? 'success' : 'danger'" v-else-if="scope.row.tradeMode === 'recharge'">
              充值
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员"
          prop="memberName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="手机号"
          prop="memberMobile"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          :label="isRedpackageSupplier ? '申报单号' : '身份证号'"
          prop="addedValue"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="金额/次数"
          prop="tradeTime"
          width="200px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.accountType === 'share' ||  scope.row.accountType === 'recharge'">
              {{ scope.row.tradeMode === "out" ? "-" : "+" }} ¥{{
                scope.row.tradeMoney
              }}
              <span class="ml10"
                >{{ scope.row.tradeMode === "out" ? "-" : "+" }}¥{{
                  scope.row.feeMoney
                }}(服务费)</span
              >
            </div>
            <div v-else>
              {{ scope.row.tradeNum
              }}{{ scope.row.accountType === "sms" ? "条" : "次" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="tradeTime"
          label="时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="afterBalance"
          label="当前项目余额"
        >
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.accountType === 'share' || scope.row.accountType === 'recharge'">¥{{ scope.row.afterBalance }}元</div>
            <div class="success" v-if="scope.row.accountType === 'sms'">{{ scope.row.afterBalance }}条</div>
            <div class="success" v-if="scope.row.accountType === 'idCard'">{{ scope.row.afterBalance }}次</div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="remark"
            label="备注"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      isOutputing: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      isRedpackageSupplier: false,
      storeName: ""
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.storeCode) {
      this.isRedpackageSupplier = true;
      this.storeName = localStorage.getItem("storeName");
    }
    this.queryList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.rechargeTime &&
        this.searchCondition.rechargeTime.length
          ? this.searchCondition.rechargeTime[0]
          : "";
      searchCondition.queryEndTime =
        this.searchCondition.rechargeTime &&
        this.searchCondition.rechargeTime.length
          ? this.searchCondition.rechargeTime[1]
          : "";
      Object.assign(params, searchCondition);
      if (this.isRedpackageSupplier) {
        params.storeCode = this.$route.query.storeCode;
        params.queryDataStoreType = "redpackageSupplier";
      }
      const { result } = await this.$store.dispatch(
        "queryAccountMoneyUseRecordList",
        params
      );

      const { total, records } = result;
      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
